/* eslint-disable no-unreachable */
import React, { useEffect, useState, } from "react"
import { Modal, GameButton, Box } from "@fedsim/components"
import Cookies from "js-cookie"
import { HeaderTertiary, HeaderBody } from "@fedsim/components";
import { SpacedDivider } from "@fedsim/components";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "90%",
  minWidth: 300,
  maxWidth: 600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 3,
};

const defaultMessage = `We use cookies and similar technologies to understand
how you use our service and improve your experience.
By clicking accept, you accept all cookies.
 Please navigate away if you do NOT agree to these terms.`

export const COOKIE_CONSENT_KEY = 'cookie_consent'

export function CookieConsent() {
  return null;
  const consentValue = false////Cookies.get(COOKIE_CONSENT_KEY)
  const [consent, setConsent,] = useState(consentValue)

  const onAccept = () => {
    Cookies.set(COOKIE_CONSENT_KEY, true)

    setConsent(true)
  }

  useEffect(() => {
    setConsent(Cookies.get(COOKIE_CONSENT_KEY))
  }, [setConsent,])

  if (consent) return null
  return (
    <>
      <div>
        <Modal
          open={!consent}
          onClose={onAccept}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <HeaderTertiary>Cookie Consent</HeaderTertiary>
            <SpacedDivider />
            <HeaderBody>{defaultMessage}</HeaderBody>
            <br />
            <GameButton variant="contained" color="success" fullWidth autoFocus elavation={3} onClick={onAccept} data-qa={`accept-cookie-policy`}>
              Accept Cookie Policy
            </GameButton>
          </Box>
        </Modal>
      </div>
    </>
  )
}

export default CookieConsent;
